const GameAssetsTemplateEnum = Object.freeze({
  TEAMS: 'teams',
  GAME: 'game',
  FONTS: 'fonts',
  SOUNDS: 'sounds'
})

const GameAssetsAllowedExtensions = Object.freeze({
  IMAGES: ['png', 'jpg', 'jpeg', 'svg', 'webp', 'gif'],
  FONTS: ['ttf', 'otf', 'woff'],
  SOUNDS: ['mp3', 'wav']
})

const GameAssetsTemplateToExtensionMap = Object.freeze({
  [GameAssetsTemplateEnum.TEAMS]: GameAssetsAllowedExtensions.IMAGES,
  [GameAssetsTemplateEnum.GAME]: GameAssetsAllowedExtensions.IMAGES,
  [GameAssetsTemplateEnum.FONTS]: GameAssetsAllowedExtensions.FONTS,
  [GameAssetsTemplateEnum.SOUNDS]: GameAssetsAllowedExtensions.SOUNDS
})

export {
  GameAssetsTemplateEnum,
  GameAssetsAllowedExtensions,
  GameAssetsTemplateToExtensionMap
}



// WEBPACK FOOTER //
// ./src/modules/gamification/enum/GameAssetsTemplateEnum.js